import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Button } from "react-bootstrap";

import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import { initFilterInput, renderColumns } from "./constants";
import Swal from "sweetalert2";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";
import CustomTable from "../../components/common/Table/CustomTable";
import Title from "../../components/common/Title/Title";

export default function Jabatan() {
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [id, setId] = useState("");
  const [description, setDescription] = useState();
  const [roleName, setRoleName] = useState();
  const [modalAdd, setMoadalAdd] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [tablePagination, setTablePagination] = useState({});

  useEffect(() => {
    getData();
    // getOutlet();
    // getJabatan();
  }, [filterInput]);

  const getData = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}jabatan`;
    let params = {
      name: filterInput.searchName,
      page: filterInput.page,
      size: filterInput.pageSize,
    };
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        let data = response.data.data;
        setRecords(data.items);
        setTotalRecords(data.total_item);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleSubmit = () => {
    setSubmitting(true);

    let data = {
      name: roleName,
      description: description,
    };

    if (id === "") {
      let url = `${process.env.REACT_APP_BASE_API_URL}jabatan`;
      httpclient
        .POST(url, data)
        .then((response) => {
          console.log(response);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
          setMoadalAdd(false);
          handleCloseModal();
          // window.location.reload(false);
        })
        .catch((error) => {
          if (error.response) {
            setSubmitting(false);
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
            setSubmitting(false);
          }
        });
    } else {
      let url = `${process.env.REACT_APP_BASE_API_URL}jabatan/${id}`;
      httpclient
        .PUT(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
          setMoadalAdd(false);
          setSubmitting(false);
          handleCloseModal();
          // window.location.reload(false);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
            setSubmitting(false);
          }
        });
    }
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}jabatan/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus jabatan " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  const handleEdit = (record) => {
    setMoadalAdd(true);
    setRoleName(record.name);
    setDescription(record.description);
    setId(record.id);
  };

  const handleCloseModal = () => {
    setSubmitting(false);
    setMoadalAdd(false);
    setRoleName("");
    setDescription("");
    setId("");
  };

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (e.key === "Enter" || e.keyCode === 13) {
      setFilterInput((prev) => ({
        ...prev,
        searchName: value,
      }));
    }
  };

  return (
    <>
      <div>
        <div className="p-3">
          <Title text="Daftar Jabatan" />
          <Breadcrumb current="Daftar Jabatan" />
          <div className="d-flex pt-3 mt-2">
            <div className="">
              <div style={{ color: "#A6A6A6" }}>Nama Jabatan</div>
              <input
                type="text"
                className="form-control border-97A0AE mt-1"
                placeholder="Cari Nama"
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div className="ml-auto">
              <CanAccess
                role={AuthorizationList.create_jabatan}
                yes={
                  <button
                    onClick={() => setMoadalAdd(true)}
                    className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold"
                  >
                    + Tambah Jabatan
                  </button>
                }
              />
            </div>
          </div>
          <div className="mt-3">
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal show={modalAdd} onHide={handleCloseModal}>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Tambah Jabatan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: "#A6A6A6" }}>Nama Jabatan :</div>
                <div style={{ color: "#A6A6A6", marginTop: 20 }}>
                  Deskripsi Pekerjaan :
                </div>
              </div>

              <div style={{ flex: 2 }}>
                <input
                  required
                  type="text"
                  className="form-control border-97A0AE"
                  placeholder="Nama ..."
                  defaultValue={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                />
                <textarea
                  required
                  rows="6"
                  style={{ marginTop: 10 }}
                  type="text"
                  className="form-control border-97A0AE"
                  placeholder="Deskripsi ..."
                  defaultValue={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleCloseModal}
              style={{
                border: "0.75px solid #DCDCDC",
                borderRadius: 6,
                width: 120,
                color: "#000",
                background: "#FFFFFF",
              }}
            >
              Kembali
            </Button>
            <Button
              type="submit"
              disabled={submitting}
              onClick={handleSubmit}
              style={{
                border: "0.75px solid #DCDCDC",
                borderRadius: 6,
                width: 120,
                color: "#fff",
                background: "#2C465C",
              }}
            >
              Simpan
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
